import React, { useState } from 'react';
import { Kicker, CharReveal } from './ui';
const ITEMS = [{
  q: 'How fast can we start?',
  a: 'Discovery calls happen within 48 hours of your message. Most projects kick off within two weeks of signing, sooner for Sprints.'
}, {
  q: 'Do you work outside Nigeria?',
  a: 'About 80 percent of our clients are in the US, UK and Canada. We work async-first, overlap with your working hours, and every deliverable lands with documentation so nothing depends on a meeting.'
}, {
  q: 'What do you need from us?',
  a: 'One decision maker, honest answers in discovery, and feedback inside agreed windows. We handle everything else.'
}, {
  q: 'Who owns the work?',
  a: 'You do. Full source files, fonts licensed in your name, and handover documentation on final payment. No hostage situations.'
}, {
  q: 'What if we only need one thing?',
  a: 'Sprints exist for exactly that: a site, an identity, a launch film. Scoped, priced, shipped.'
}];
function Row({
  q,
  a,
  open,
  onToggle
}: {
  q: string;
  a: string;
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b" style={{
    borderColor: 'var(--line)'
  }} data-id="element-8">
      <button onClick={onToggle} aria-expanded={open} className="flex w-full items-center justify-between gap-6 py-6 md:py-8 text-left" data-id="element-9">
        <span className="font-display uppercase text-lg md:text-2xl tracking-tight" data-id="element-10">{q}</span>
        <span className="relative flex h-6 w-6 shrink-0 items-center justify-center transition-transform duration-300" style={{
        transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
        color: 'var(--danfo)'
      }} aria-hidden="true" data-id="element-11">
          <span className="absolute h-[2px] w-5" style={{
          background: 'currentColor'
        }} data-id="element-12" />
          <span className="absolute h-5 w-[2px]" style={{
          background: 'currentColor'
        }} data-id="element-13" />
        </span>
      </button>
      <div className="grid transition-all duration-500 ease-in-out" style={{
      gridTemplateRows: open ? '1fr' : '0fr'
    }} data-id="element-14">
        <div className="overflow-hidden" data-id="element-15">
          <p className="max-w-2xl pb-7 text-base md:text-lg leading-relaxed" style={{
          color: 'var(--paper-dim)'
        }} data-id="element-16">
            {a}
          </p>
        </div>
      </div>
    </div>;
}
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32" data-id="element-17">
      <Kicker ig="Ajụjụ" en="Questions" data-id="element-18" />
      <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-19">
        <CharReveal text="FAQ" step={60} data-id="element-20" />
      </h2>
      <div className="mt-10 md:mt-14 border-t" style={{
      borderColor: 'var(--line)'
    }} data-id="element-21">
        {ITEMS.map((item, i) => <Row key={item.q} q={item.q} a={item.a} open={open === i} onToggle={() => setOpen(open === i ? null : i)} data-id="element-22" />)}
      </div>
    </section>;
}